var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Button from '@web/components/layout/Button';
import Toggle from '@web/components/layout/Toggle/Toggle';
import DangerZone from '@web/components/Settings/DangerZone/DangerZone';
import { IpAddressInput } from '@web/components/Settings/GeneralSettings/IpAddressInput';
import { WorkingHoursSection } from '@web/components/Settings/GeneralSettings/WorkingHoursSection';
import { TimezoneSection } from '@web/components/Settings/TimezoneSection/TimezoneSection';
import { Tooltip } from '@web/components/ui/Tooltip';
import { IS_DEMO } from '@web/config';
import { useUserContext } from '@web/contexts/User';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { createSettingsToasts } from '@web/utility/toastUtils';
import { Field, Form, Formik } from 'formik';
import { t } from 'i18next';
var GeneralSettings = function () {
    var _a = useUserContext(), currentUser = _a.currentUser, refetch = _a.refetch;
    var toast = useToast().toast;
    var updateWorkspaceSettings = trpc.updateWorkspaceSettings.useMutation();
    var _b = createSettingsToasts(toast, t), showSuccessToast = _b.showSuccessToast, showErrorToast = _b.showErrorToast;
    if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.workspace))
        return null;
    var workspace = currentUser.workspace;
    var startWorkingHour = workspace.startWorkingHour, endWorkingHour = workspace.endWorkingHour;
    var officeIpAddressesJson = workspace.officeIpAddresses;
    var initialIpAddresses = Array.isArray(officeIpAddressesJson)
        ? officeIpAddressesJson
        : [];
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedSettings, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (values.startWorkingHour >= values.endWorkingHour) {
                        showErrorToast('generalSettings.workingHoursInvalidRange');
                        return [2 /*return*/];
                    }
                    if (IS_DEMO) {
                        showSuccessToast();
                        return [2 /*return*/];
                    }
                    updatedSettings = {
                        workspaceId: workspace.id,
                        billingContact: values.billingEmail,
                        timezone: values.timezone,
                        useIdsAsTitles: values.useIdsAsTitles,
                        officeIpAddresses: values.officeIpAddresses,
                        startWorkingHour: values.startWorkingHour,
                        endWorkingHour: values.endWorkingHour
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updateWorkspaceSettings.mutateAsync(updatedSettings)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, refetch()];
                case 3:
                    _b.sent();
                    showSuccessToast();
                    return [3 /*break*/, 5];
                case 4:
                    _a = _b.sent();
                    showErrorToast();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Formik, __assign({ enableReinitialize: true, initialValues: {
                    billingEmail: workspace.billingContact || '',
                    timezone: workspace.timezone,
                    useIdsAsTitles: workspace.useIdsAsTitles,
                    officeIpAddresses: initialIpAddresses,
                    startWorkingHour: startWorkingHour,
                    endWorkingHour: endWorkingHour
                }, onSubmit: onSubmit }, { children: function (_a) {
                    var _b;
                    var values = _a.values, handleSubmit = _a.handleSubmit, handleChange = _a.handleChange, setFieldValue = _a.setFieldValue;
                    var handleAddIpAddress = function (ip) {
                        var updatedIps = __spreadArray(__spreadArray([], values.officeIpAddresses, true), [ip], false);
                        setFieldValue('officeIpAddresses', updatedIps);
                    };
                    var handleRemoveIpAddress = function (ipToRemove) {
                        var updatedIps = values.officeIpAddresses.filter(function (ip) { return ip !== ipToRemove; });
                        setFieldValue('officeIpAddresses', updatedIps);
                    };
                    return (_jsxs(Form, __assign({ onSubmit: handleSubmit }, { children: [_jsx("div", __assign({ className: "mb-5 sm:rounded-lg shadow px-4 py-5 sm:p-6" }, { children: _jsxs("div", __assign({ className: "mt-5 flex flex-col sm:flex-row gap-5" }, { children: [_jsxs("div", __assign({ className: "mt-1 text-sm text-gray-500 w-1/2" }, { children: [_jsx("h3", __assign({ className: "text-xl leading-6 font-semibold text-gray-900 mb-3" }, { children: (_b = workspace.primaryDomain) === null || _b === void 0 ? void 0 : _b.name })), _jsx("p", { children: t('generalSettings.primaryDomainDescription') })] })), _jsxs("div", __assign({ className: "flex flex-col mt-1 w-1/2" }, { children: [_jsxs("div", __assign({ className: "flex items-center text-sm text-gray-500" }, { children: [_jsx(Toggle, { enabled: values.useIdsAsTitles, disabled: true, onChange: function () { } }), _jsx("p", __assign({ className: "text-sm font-semibold text-gray-900 pl-2" }, { children: t('generalSettings.useIdsAsTitles') })), _jsx(Tooltip, __assign({ content: t('generalSettings.useIdsAsTitlesTooltip'), place: "bottom", className: "max-w-[350px] z-50", tooltipContainerClassName: "ml-1.5 inline-flex" }, { children: _jsx(InformationCircleIcon, { className: "h-5 w-5 text-gray-500 cursor-pointer" }) }))] })), _jsx("p", __assign({ className: "text-xs text-red-500 pl-12 mt-1" }, { children: t('generalSettings.comingSoon') }))] }))] })) })), _jsxs("div", __assign({ className: "flex flex-col sm:flex-row gap-5" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-3 sm:rounded-lg p-3 sm:p-6 shadow sm:w-1/2" }, { children: [_jsx("h3", __assign({ className: "text-xl leading-6 font-medium text-gray-900 mb-3" }, { children: t('generalSettings.billingContact') })), _jsx("div", __assign({ className: "flex flex-col max-w-80 gap-4 text-sm text-gray-500" }, { children: _jsx(Field, { type: "email", id: "billingEmail", name: "billingEmail", placeholder: "you@example.com", className: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md", required: true }) })), _jsx("p", __assign({ className: "text-sm text-gray-500 w-2/3" }, { children: t('generalSettings.billingDescription') }))] })), _jsx(TimezoneSection, { onChange: function (option) {
                                            handleChange({
                                                target: {
                                                    name: 'timezone',
                                                    value: option.id
                                                }
                                            });
                                        }, selectedTimeZone: values.timezone })] })), _jsxs("div", __assign({ className: "flex flex-col sm:flex-row gap-5 mt-5" }, { children: [_jsx(WorkingHoursSection, { startWorkingHour: values.startWorkingHour, endWorkingHour: values.endWorkingHour, onStartChange: function (value) {
                                            return setFieldValue('startWorkingHour', value);
                                        }, onEndChange: function (value) {
                                            return setFieldValue('endWorkingHour', value);
                                        } }), _jsx(IpAddressInput, { officeIpAddresses: values.officeIpAddresses, onAdd: handleAddIpAddress, onRemove: handleRemoveIpAddress, workspaceId: workspace.id })] })), _jsx("div", __assign({ className: "flex justify-end" }, { children: _jsx(Button, __assign({ variant: "primary", type: "submit", className: "mt-5", disabled: values.startWorkingHour >= values.endWorkingHour }, { children: t('button.save') })) }))] })));
                } })), !IS_DEMO && _jsx(DangerZone, {})] }));
};
export default GeneralSettings;
